export default "__VITE_ASSET__DUrh0iht__"